import {getOutlet} from 'reconnect.js';
import * as AppActions from '../AppActions';

const TEST_CONSTANTS = {
  test: 'test',
};

const THEME_COLOR = '#616161';
const THEME_COLOR_SECOND = '#B18854';

const SITE_INFO = {
  title: '雅浩家具 健康辦公',
  subtitle: 'Dashboard',
  icon: '/images/favicon.png',
  address: '105 台北市松山區敦化北路214號2樓',
};

const LOGIN_REQUIRED_CONFIG = {
  image: '/images/permission-denied.jpeg',
  title: '尚未登入',
  subtitle: '此頁面需要登入，方能瀏覽',
  buttonText: '登入',
  onButtonClick: ({admin}) => {
    const loginModal = getOutlet('login-modal');
    loginModal.update({admin});
  },
};

const EMPTY_CONFIG = {
  image: '/images/permission-denied.jpeg',
  title: '敬請期待',
  subtitle: '此頁面目前沒有資料',
  buttonText: '前往首頁',
  onButtonClick: async () => await AppActions.navigate('/'),
};

export {
  TEST_CONSTANTS,
  THEME_COLOR,
  THEME_COLOR_SECOND,
  SITE_INFO,
  LOGIN_REQUIRED_CONFIG,
  EMPTY_CONFIG,
};
